import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import WhatsAppCampaignAnalyticsPage from 'dashboard/components-next/Campaigns/Pages/CampaignAnalytics/WhatsAppCampaignAnalyticsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', 'campaign_manage'],
};

export const whatsappFlowsMeta = {
  featureFlag: FEATURE_FLAGS.WHATSAPP_FLOWS,
  permissions: ['administrator', 'campaign_manage'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        // Only WhatsApp campaigns are offered; legacy channel URLs land there too
        ...['', 'ongoing', 'one_off', 'live_chat', 'sms'].map(path => ({
          path,
          redirect: to => ({
            name: 'campaigns_whatsapp_index',
            params: to.params,
          }),
        })),
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta,
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'whatsapp/:campaignId/analytics',
          name: 'campaigns_whatsapp_analytics',
          meta,
          component: WhatsAppCampaignAnalyticsPage,
        },
        {
          path: 'multi_step',
          name: 'campaigns_multi_step_index',
          meta: whatsappFlowsMeta,
          component: () => import('../whatsapp_flows/Index.vue'),
        },
      ],
    },
  ],
};

export default campaignsRoutes;
